"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _formulas = _interopRequireDefault(require("../../../util/formulas"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _times = _interopRequireDefault(require("lodash/times"));

var _map = _interopRequireDefault(require("lodash/map"));

var _sum = _interopRequireDefault(require("lodash/sum"));

var _class, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var AmortizationTableModel = (_class = /*#__PURE__*/function () {
  function AmortizationTableModel(loan, maxTermInMonths) {
    _classCallCheck(this, AmortizationTableModel);

    _initializerDefineProperty(this, "extraPayments", _descriptor, this);

    this.loan = loan;
    this.extraPayments = (0, _times.default)(this.loan.term, function (n) {
      return 0;
    }); // default to 100 years

    this.maxTermInMonths = maxTermInMonths || 1200;
  }

  _createClass(AmortizationTableModel, [{
    key: "timeline",
    get: function get() {
      var _this = this;

      var principal = this.loan.balance;
      var defaultPrincipal = this.loan.balance;
      var totalInterest = 0;
      var defaultTotalInterest = 0;

      var monthlyRate = _formulas.default.monthlyInterest(this.loan.rate);

      return (0, _times.default)(this.loan.term, function (i) {
        var interest = principal * monthlyRate;
        totalInterest += interest;
        var defaultInterest = defaultPrincipal * monthlyRate;
        defaultTotalInterest += defaultInterest;
        principal = principal + interest - _this.loan.monthlyPayment - _this.extraPayments[i];
        principal = principal < 0 ? 0 : principal;
        defaultPrincipal = defaultPrincipal + defaultInterest - _this.loan.monthlyPayment;
        defaultPrincipal = defaultPrincipal < 0 ? 0 : defaultPrincipal;
        return {
          principal: principal,
          totalInterest: totalInterest,
          interest: interest,
          defaults: {
            principal: defaultPrincipal,
            totalInterest: defaultTotalInterest,
            interest: defaultInterest
          }
        };
      });
    }
  }, {
    key: "getMonthlyPayment",
    value: function getMonthlyPayment() {
      if (!(this.loan.rate && this.loan.balance && this.loan.term)) {
        return null;
      }

      return _formulas.default.estimatedMonthlyPayment(this.loan.rate, this.loan.balance, this.loan.term);
    }
  }, {
    key: "getEstimatedTerm",
    value: function getEstimatedTerm() {
      if (!((this.loan.rate || (0, _isEqual.default)(this.loan.rate, 0)) && this.loan.balance && this.loan.monthlyPayment)) {
        return null;
      }

      var estimatedTerm = _formulas.default.estimatedPayoutTerm(this.loan.rate, this.loan.balance, this.loan.monthlyPayment);

      if (!(0, _isNull.default)(estimatedTerm) && estimatedTerm > this.maxTermInMonths) {
        estimatedTerm = null;
      }

      return estimatedTerm;
    }
  }, {
    key: "applyExtraPayments",
    value: function applyExtraPayments(payments) {
      var _this2 = this;

      (0, _forEach.default)(payments, function (amount, month) {
        if (month >= 0 && month < _this2.extraPayments.length) {
          _this2.extraPayments[month] += amount;
        }
      });
    }
  }, {
    key: "applyExtraPaymentToMonth",
    value: function applyExtraPaymentToMonth(month, extraPayment) {
      if (month >= this.extraPayments.length) {
        return;
      }

      this.extraPayments[month] += extraPayment;
    }
  }, {
    key: "applyExtraPaymentAfter",
    value: function applyExtraPaymentAfter(startMonth, extraPayment) {
      if (startMonth >= this.extraPayments.length) {
        return;
      }

      for (var index = startMonth; index < this.extraPayments.length; index++) {
        this.extraPayments[index] += extraPayment;
      }
    }
  }, {
    key: "resetPayments",
    value: function resetPayments() {
      this.extraPayments = (0, _times.default)(this.loan.term, function (n) {
        return 0;
      });
    }
  }, {
    key: "getEndOfTerm",
    value: function getEndOfTerm() {
      var monthlyBalances = this.getPrincipalAfterEachMonth();
      var monthIndex = (0, _findIndex.default)(monthlyBalances, function (principal) {
        return principal === 0;
      });
      return monthIndex === -1 ? this.loan.term : monthIndex + 1;
    }
  }, {
    key: "getTotalInterestPaid",
    value: function getTotalInterestPaid() {
      return this.getInterestPaidAfterMonth(this.loan.term - 1);
    }
  }, {
    key: "getDefaultInterestPaid",
    value: function getDefaultInterestPaid() {
      return this.getDefaultInterestPaidAfterMonth(this.loan.term - 1);
    }
  }, {
    key: "getPrincipalAfterEachMonth",
    value: function getPrincipalAfterEachMonth() {
      return (0, _map.default)(this.timeline, "principal");
    }
  }, {
    key: "getDefaultPrincipalAfterEachMonth",
    value: function getDefaultPrincipalAfterEachMonth() {
      return (0, _map.default)(this.timeline, function (month) {
        return month.defaults.principal;
      });
    }
  }, {
    key: "getPrincipalAfterMonth",
    value: function getPrincipalAfterMonth(month) {
      return this.getPrincipalAfterEachMonth()[month];
    }
  }, {
    key: "getInterestPaidAfterEachMonth",
    value: function getInterestPaidAfterEachMonth() {
      return (0, _map.default)(this.timeline, "totalInterest");
    }
  }, {
    key: "getDefaultInterestPaidAfterEachMonth",
    value: function getDefaultInterestPaidAfterEachMonth() {
      return (0, _map.default)(this.timeline, function (month) {
        return month.defaults.totalInterest;
      });
    }
  }, {
    key: "getInterestPaidAfterMonth",
    value: function getInterestPaidAfterMonth(month) {
      return this.getInterestPaidAfterEachMonth()[month];
    }
  }, {
    key: "getDefaultInterestPaidAfterMonth",
    value: function getDefaultInterestPaidAfterMonth(month) {
      return this.getDefaultInterestPaidAfterEachMonth()[month];
    }
  }, {
    key: "getInterestPaidInEachMonth",
    value: function getInterestPaidInEachMonth() {
      return (0, _map.default)(this.timeline, "interest");
    }
  }, {
    key: "getDefaultInterestPaidInEachMonth",
    value: function getDefaultInterestPaidInEachMonth() {
      return (0, _map.default)(this.timeline, function (month) {
        return month.defaults.interest;
      });
    }
  }, {
    key: "getInterestPaidInMonth",
    value: function getInterestPaidInMonth(month) {
      return this.getInterestPaidInEachMonth()[month];
    }
  }, {
    key: "_getCostRemainingByYear",
    value: function _getCostRemainingByYear(getInterest, getPrincipal) {
      var costs = [];
      var totalInterestRemaining = 0;

      for (var i = this.loan.term - 1; i >= 0; i--) {
        var data = this.timeline[i];

        if ((this.loan.term - i - 1) % 12 === 0) {
          costs.push(getPrincipal(data) + totalInterestRemaining);
        }

        totalInterestRemaining += getInterest(data);
      }

      costs.push(this.loan.balance + totalInterestRemaining);
      return costs.slice(1).reverse();
    }
  }, {
    key: "getCostRemainingByYear",
    value: function getCostRemainingByYear() {
      return this._getCostRemainingByYear(function (data) {
        return data.interest;
      }, function (data) {
        return data.principal;
      });
    }
  }, {
    key: "getDefaultCostRemainingByYear",
    value: function getDefaultCostRemainingByYear() {
      return this._getCostRemainingByYear(function (data) {
        return data.defaults.interest;
      }, function (data) {
        return data.defaults.principal;
      });
    }
  }, {
    key: "getInterestPaidInYear",
    value: function getInterestPaidInYear(year) {
      var startMonth = (year - 1) * 12;
      var endMonth = year * 12;

      if (startMonth > this.timeline.length) {
        return null;
      }

      return (0, _sum.default)(this.getInterestPaidInEachMonth().slice(startMonth, endMonth));
    }
  }, {
    key: "getDefaultInterestPaidInYear",
    value: function getDefaultInterestPaidInYear(year) {
      var startMonth = (year - 1) * 12;
      var endMonth = year * 12;

      if (startMonth > this.timeline.length) {
        return null;
      }

      return (0, _sum.default)(this.getDefaultInterestPaidInEachMonth().slice(startMonth, endMonth));
    }
  }, {
    key: "getUnusedPaymentForLastMonth",
    value: function getUnusedPaymentForLastMonth() {
      var monthlyBalances = this.getPrincipalAfterEachMonth();
      var lastMonth = (0, _findIndex.default)(monthlyBalances, function (principal) {
        return principal === 0;
      });
      var lastMonthPayment = this.getPrincipalAfterMonth(lastMonth - 1) + this.getInterestPaidInMonth(lastMonth);
      return this.extraPayments[lastMonth] + this.loan.monthlyPayment - lastMonthPayment;
    }
  }]);

  return AmortizationTableModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "extraPayments", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "timeline", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeline"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyExtraPayments", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "applyExtraPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyExtraPaymentToMonth", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "applyExtraPaymentToMonth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyExtraPaymentAfter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "applyExtraPaymentAfter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPayments", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetPayments"), _class.prototype)), _class);
exports.default = AmortizationTableModel;